import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios';
import Serverurl from './Apiurl';
import Addschedulebox from './Orderfunction';
import Table from '@mui/material/Table';
import HistoryIcon from '@mui/icons-material/History';
import MoreTimeIcon from '@mui/icons-material/MoreTime';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs, { Dayjs } from 'dayjs';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import AddCardIcon from '@mui/icons-material/AddCard';
import Collapse from '@mui/material/Collapse';

import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
const headCells = [
  
  { id: 'or_orderno', numeric: false, label: 'Invoice No.' },
   { id: 'or_invoicedate', numeric: false, label: 'Invoice Date' },
  { id: 'or_name', numeric: false, label: 'Name' },
 
    { id: 'or_classtype', numeric: false, label: 'Preference - Duration' },


	
	{ id: 'classstartdate', numeric: false, label: 'Schedule Date' },
	{ id: 'or_totalamount', numeric: false, label: 'Subtotal' },
	{ id: 'or_extramt', numeric: false, label: 'Extra' },
	{ id: 'or_discount', numeric: false, label: 'Discount' },
	{ id: 'gstamount', numeric: false, label: 'GST' },
		{ id: 'total', numeric: false, label: 'Total' },
   { id: '',  label: '' }, { id: '',  label: '' },
  ]
  function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});
 export default class OrderManage extends Component {

   constructor(props) {
      super(props);
	   var strdob=new Date();
	 var month="";
	
	 if((strdob.getMonth() + 1)<10)
	 {
		month="0"+ (strdob.getMonth() + 1)		 
	 }else{month=(strdob.getMonth() + 1)}
            this.state = {orderdata:[],page: 0,subid:'', prevpage:0,totaldata:0,rowsPerPage:20,subscribeData:[],rowsPaging:[], order:'desc' ,orderBy:'',names:'', redirect:false,pagename:'',paytype:'',invoicedate:dayjs(Date.now()),invoicedate1:'',classtype:'',orderno:'',orname:'',oractive:'1',type:'',orid:'',Branchdata:[],branchid:'',invoicetodate1:'',invoicetodate:dayjs(Date.now())}
			this.updateDonenewParent = this.updateDonenewParent;
   }
      
   updateDonenewParent = (text) => {   this.apiOrdercall(this.state.page,this.state.rowsPerPage); }
   myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val},()=>{ 
  if(nam==="classtype")
 {this.setState({oractive: ''});
	
 }}); 

} 
	  


	componentWillMount  () {
	

	
	document.title = "AthaYog Living - Order Management";
	
	if(localStorage.getItem("AYLuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Default'
          })
		  }
	
	this.onloadBranch();
	
	  localStorage.setItem("page",this.state.rowsPerPage)
  this.apiOrdercall(this.state.page,this.state.rowsPerPage);
  
} 		
 onloadBranch()
{
	axios.post(Serverurl+'ajaxbranch.php?action=getall&sorting=bm_id')
  .then(resp => {  
		
  if(resp.data.length>0){
	  this.setState({Branchdata:resp.data,},()=>{
								let strbrid=this.state.branchid;

								if(resp.data.length===1 && strbrid!='')
								{
									strbrid=resp.data[0]["bm_id"];
								}
								 let BranchFromApi = this.state.Branchdata.map(row => {
                          
          return {value:row.bm_id,display:row.bm_name}
        });
      
		
        this.setState({branchid:strbrid,
          Branchdata: [{value: '0', display:'Select Branch'}].concat(BranchFromApi)
        });
								
							})


							
  }else{
	  this.setState({Branchdata:[]});
  }
   this.onloadsubscribeBind();
  });
	
} 
  
apiOrdercall(page,rowsPerPage){
	let strbranch=this.state.branchid;
	 if(localStorage.getItem("AYLrole")!=="1")
	 {
		 strbranch=localStorage.getItem("AYLbrid");
	 }
	 axios.get(Serverurl+'ajaxorders.php?action=list&StartIndex='+page+'&PageSize='+rowsPerPage+'&or_sb_id='+this.state.subid+'&or_orderno='+this.state.orderno+'&or_name='+this.state.orname+'&or_invoicedate='+this.state.invoicedate1+'&or_invoicetodate='+this.state.invoicetodate1+'&or_enddate='+this.state.oractive+'&or_booktype=1,3&or_bm_id='+strbranch+'&or_paymenttype='+this.state.paytype+'&or_classtype='+this.state.classtype)
     
	
  .then(resp => {  
		
    if(resp.data.length>0){
		let copy=[50, 100, 150, 200, 250];
			this.setState({  
			  orderdata: resp.data,  
			   totaldata:parseInt(resp.data[0].count)
			   

		    });
	  
	 
	 
     }
	 else{
		   this.setState({orderdata:[],totaldata:0});
	 }

    });
}
	 

onloadsubscribeBind(){
  axios.post(Serverurl+'ajaxsubscription.php?action=getall&sb_type=1,2,3,4,6&sorting=sb_type')
  .then(resp => {  
		
  if(resp.data.length>0){
				
				
				this.setState({
						subscribeData:resp.data	
							},()=>{
								
								
								 let subscribeFromApi = this.state.subscribeData.map(row => {
                          
          return {value:row.sb_id,display:row.sb_title,label:row.type,type:row.sb_type}
						 
        });
      
	
        this.setState({
          subscribeData: [{value: '', display:'Select Duration',label:'',type:'0'}].concat(subscribeFromApi)
        },()=>{});
								
							})
	
														
			}else{
				this.setState({subscribeData:[]});
			}
 
    });

}
handleChangePage = (event, newPage) => {  

    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apiOrdercall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  };   

  handleClickSearch=()=>{  
  
  this.apiOrdercall(this.state.page,this.state.rowsPerPage);

  } 
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apiOrdercall(this.state.page,this.state.rowsPerPage); }); 
	
	
  }; 
  
  
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};	  
	  
handdateChanges = (date) => {
	
	  var month="";
 var date1 = new Date(date);
var todate1 = new Date(date);
	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}   
	 
	 todate1.setDate(date1.getDate() + 1);
	
     this.setState({ invoicedate:dayjs(date),
invoicedate1:date1.getFullYear() + '-' + month + '-' +date1.getDate(),
invoicetodate: todate1,
invoicetodate1:todate1.getFullYear() + '-' + month + '-' +todate1.getDate()
	 })
	
	
  }
  handtodateChanges = (date) => {
	
	  var month="";
 var date1 = new Date(date);

	 if((date1.getMonth() + 1)<10)
	 {
		month="0"+ (date1.getMonth() + 1)		 
	 }else{month=(date1.getMonth() + 1)}   
     this.setState({ invoicetodate:dayjs(date),
invoicetodate1:date1.getFullYear() + '-' + month + '-' +date1.getDate()
	 })
	
	
  }
  
  triggerimport(){
		this.refs.Importinventory.handleClickOpen();
		  
	  }
  
	extendrequest(orid,classtype){
	
	 let r = window.confirm("Do you really want to Extend?");
		 if(r == true){ //sign Out logic
		  this.setState({orid:orid,type:classtype},()=>{
			  
			  this.refs.Addschedulebox.handleClickOpen()}); 
		 }
 
 } 
/*<li><p >
		<Button  variant="contained"  

onClick={()=>{this.triggerimport()}}    className="primarybtn" >
				Import 	
		</Button></p >
</li> */ 
render() { 
  
  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
  
 let prev="";
  
  return (
  

<React.Fragment>
<div className="boxheading">
				
<h2> Manage Orders </h2>
</div>
<div className="clear"></div>

 <div className="searchmaster">

 <Importinventory ref="Importinventory"  updateDonenew={this.updateDonenewParent}/>
  
  <ul>
  {localStorage.getItem("AYLrole")==="1" && (
  <li>
<p>Select Branch</p>

<p>
<FormControl  className="stadrp">			   
			<Select
			className="txtbox"
			native
			value={this.state.branchid}
			onChange={this.myChangeHandler}
			name='branchid'
			
			fullwidth
			
			
			>
		
		
			{this.state.Branchdata.map(row => (
				<option  
            
				  value={row.value}
				>
				  {row.display}
				</option  >
			  ))}
			 </Select>
		</FormControl>
</p>
</li>
  )}
  <li><p>Invoice No.</p><p><TextField
            variant="outlined"
            margin="normal"
            fullWidth value={this.state.orderno}
        inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
			
            name="orderno" onChange={this.myChangeHandler}
		
          /></p></li>
		  <li><p>Name/ Email/ Phone</p><p><TextField
            variant="outlined"
            margin="normal"
            fullWidth value={this.state.orname}
        inputProps={{tabIndex: "2",maxLength:150}} className="txtbox"
			
            name="orname" onChange={this.myChangeHandler}
		
          /></p></li>
		  <li><p>Class Type</p>
	<p><FormControl  className="stadrp">
				
		 <Select
         native
		 variant="outlined" inputProps={{tabIndex: "2"}}
		  className="txtbox"
          margin="normal"
          onChange={this.myChangeHandler}
          id="type"
		   value={this.state.classtype}
		  name="classtype"
		
        >
	
	<option value="">Select Your Type</option>
                  <option value={1}>Personal Training at Home</option>
          <option value={2}>Personal Training in studio</option>
 <option value={3}>Group</option>
 <option value={4}>Prenatal</option> <option value={5}>Products</option>
 <option value={6}>Personal Training Online</option>
 <option value={7}>TTC</option>
        </Select>

		</FormControl>
		</p>
	</li>
 <li><p>Duration</p>
 
 <p><FormControl  className="stadrp">			   
			<Select
			 className="txtbox"
			native 	inputProps={{tabIndex: "3"}}
			value={this.state.subid}
			onChange={this.myChangeHandler}
			name='subid'
			
			fullwidth
			
			
			>
		
		
			{this.state.subscribeData.map((row,index) =>{
	
	
		this.state.subscribeData.filter(options => options.type == row.type);
	
	if(prev!=row.type)
	{
	prev=row.type
				return(
				 <React.Fragment>
				  <optgroup label={row.label}>
				 {this.state.subscribeData.filter(options => options.type == row.type).map((sub) =>{ return(
			
				
				<option  
            
				  value={sub.value}
				>
				  {sub.display}
				</option  >
				
				)})}
		</optgroup>
	 </React.Fragment>			 
	)
	}
	
	})}
			 </Select>
		</FormControl></p></li>
		<li><p> Payment Type</p>
 
 <p><FormControl  className="stadrp">
  <Select
         native
		 variant="outlined" className="txtbox"
          margin="normal"
          onChange={this.myChangeHandler}
          id="paytype"
		   value={this.state.paytype}
		  name="paytype"
		inputProps={{tabIndex: "4"}}
        >
	<option value="">Select Type</option>
	<option value={1}>Online </option>
	<option value={2}>Cash</option>	
	<option value={3}>UPI</option>	
	<option value={4}>Card</option>
        </Select>

		</FormControl></p>
		
 </li>
 <li>
 <p>From Date</p>

<p> <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.invoicedate) }
className="txtbox" 
    onChange={this.handdateChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
</p>
 </li>
 
  <li>
 <p>To Date</p>

<p> <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.invoicetodate) }
className="txtbox" 
    onChange={this.handtodateChanges} format="DD/MM/YYYY"
/>  </DemoContainer>
    </LocalizationProvider>
</p>
 </li>
 <li>
 <p>Status</p>
  <p><FormControl  className="stadrp">
  <Select
         native
		 variant="outlined" className="txtbox"
          margin="normal"
          onChange={this.myChangeHandler}
          id="oractive"
		   value={this.state.oractive}
		  name="oractive"
		inputProps={{tabIndex: "5"}}
        >
	<option value="">Select Type</option>
	<option value={1}>Active</option>
	<option value={2}>Inactive</option>	
	<option value={3}>Not Paid</option>
        </Select>

		</FormControl></p>
 </li>

 		<li><p >
		<Button variant="contained" onClick={this.handleClickSearch} className="frmSecondarybtn" endIcon={<SearchIcon />}>
        Search
      </Button></p></li> 
						
		</ul>
		<p>
		<Button  variant="contained"  

onClick={()=>{this.triggerimport()}}    className="frmSecondarybtn" >
				Import 	
		</Button></p>
		
</div>
<Addschedulebox ref="Addschedulebox"  type={this.state.type} orid={this.state.orid}  updateDonenew={this.updateDonenewParent}/>	
<Paper className={useStyles.root}>


  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.orderdata.length}
            />
                      <TableBody>
                     {stableSort(this.state.orderdata, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >



<TableCell>{item.or_orderno}</TableCell>
<TableCell>{item.or_invoicedate}</TableCell>
<TableCell>{item.or_name}<br/>{item.or_email}</TableCell>

<TableCell>{item.classtype} - {item.sb_title}</TableCell>


<TableCell>{item.classstartdate} - {item.enddate}</TableCell>
<TableCell>Rs.{item.or_totalamount}</TableCell>
<TableCell>Rs.{item.or_extramt}</TableCell>
<TableCell>Rs.{item.or_discount}</TableCell>
<TableCell>Rs.{item.gstamount}</TableCell>
<TableCell>Rs.{item.total}</TableCell>
<TableCell>
{item.or_isold!=="2" &&( <React.Fragment>

{(item.or_orderno!==null && item.or_orderno!=="") && (
<a href={Serverurl+'/uploads/invoice-'+item.or_id+'.pdf'} target='_blank'>
<FileDownloadIcon/></a>)}  </React.Fragment>)}&nbsp;&nbsp;&nbsp;


<a href={'/Orderview?orid='+item.or_id+'&type=1'}>
<VisibilityIcon/></a></TableCell>


<TableCell>
{item.expireday==="0"  &&(

<a href={'/Adminbilling?orid='+item.or_id} >
<Button variant="contained" className="frmSecondarybtn" endIcon={<HistoryIcon />} >
        Renew 
      </Button></a> 
)}

{(item.or_booktype==="1" && item.or_paystatus==="1" && item.or_classtype!=="5") &&(


<Button variant="contained" onClick={()=>{this.refs.Addschedulebox.Markaspaid(item.or_id,item.total,item.or_sesssion)}} className="frmSecondarybtn" endIcon={<AddCardIcon />}>
        Pay
      </Button>
)}
{(item.or_booktype==="1" && item.or_paystatus==="2" && item.or_classtype!=="5") &&(


<Button variant="contained" onClick={()=>{this.extendrequest(item.or_id,item.or_classtype)}} className="frmSecondarybtn" endIcon={<MoreTimeIcon />}>
        Extend 
      </Button>
)}
	  </TableCell>

 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="10">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
       
        rowsPerPageOptions={[50,100,200,300,400]}
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}   
      />   
  </Paper>
</React.Fragment>
  );
  }
 }
 
 
export  class  Importinventory extends Component {
	
	 constructor(props) {
      super(props)
      this.state = {

          open:false,imgCollection: ''
      }
      
  }
   onFileChange=(e) =>{
	      let imageFile = e.target.files[0];

	   if (!imageFile.name.match(/\.(csv)$/)) {
  alert( 'Please select valid file (csv).' );
    return false;
  }else{
        this.setState({ imgCollection: e.target.files })
  }
        
    }
handleClickOpen = (e) => {

  this.setState({ open:!this.state.open,  });
		


};
handleClose = (e) => {

 

  var formData = new FormData();

  // formData.append('action','importorders')
		 formData.append('action','importleads') 
		  
	  
	  if(this.state.imgCollection!='')
	  {
		  
		for (const key of Object.keys(this.state.imgCollection)) {
            formData.append('Filedata', this.state.imgCollection[key])
        } 
		
	  
	 
	  axios.post(Serverurl+"ajaximportleads.php", formData, {
        }).then(res => {

					    alert("inventory Uploaded Successfully")

            });
  
  this.setState({ open:false });
};
}

render (){

return(
<React.Fragment>
<Dialog open={this.state.open} onClose={this.handleClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title"> Import Products</DialogTitle>
      <DialogContent>
	  <p><a href={Serverurl+'uploads/importproductsprice.csv'} target="_blank"> Download Format</a></p>
	  <p>Import</p>
						   <p> <input type="file" name="imgCollection" onChange={this.onFileChange} /></p>
   
	   </DialogContent>
     <div className="dialoguebtn">
			<ul>	  
		<li>
        <Button className="generalbtn"  onClick={this.handleClickOpen} variant="contained">
          Cancel
        </Button></li>
		<li>
        <Button className="primarybtn" onClick={this.handleClose} variant="contained">
          Save
        </Button></li>
				
				
		</ul>	
			</div>    
     
    </Dialog>
</React.Fragment>
)
}
  
  
}
	  
	